import {
    __start,
    __end,
    __break_long_mail_links_words,
    __smooth_scroll_effect,
    __get_from_local_storage,
    __scroll_more_button,
    __get_scroll_position,
    __accept_tutorial,
    __load_tutorial,
} from './parts/functions';
import { __init_free_slider, __hover_for_tooltip, __slider_widget_lists } from './parts/slider';
import { __clean_elementor_storage } from './parts/clean';
import { __toggle_menu, __handle_meta_menu_item, __small_nav_section_anchor } from './parts/menu';
// import { __handle_header_scroll } from './parts/header';
import { __add_image_caption_editor } from './parts/editor';
import {
    __trigger_video_play_stop,
    __init_video_player,
    __set_video_audio_volume,
    __start_media_video,
} from './parts/video';
import { __init_charts } from './parts/charts'
import { __init_lightboxes, __trigger_lightbox, __init_single_lightboxes } from './parts/lightbox';
import { __full_page_scroll, __handle_key_navigation } from './parts/fullpage';
import { __trigger_modal, __trigger_share_modal, __share_functions } from './parts/modal';
import { Settings } from './classes/Settings';

import AOS from 'aos';

// import 'aos/dist/aos.css';

(function ($) {
    'use strict';

    $(window).on('load', async function () {
        /* Start and initial functions */
        __start();

        /* Init the page settings */
        let GLOBAL_SETTINGS = new Settings({
            volume: await __get_from_local_storage('volume'),
        });

        /* Clean the storage from elementor entries */
        await __clean_elementor_storage();

        /* Clean the storage from elementor entries */
        __smooth_scroll_effect();

        /* Scroll more button */
        __scroll_more_button();

        /* Add editor image captions */
        __add_image_caption_editor();

        /* Trigger video play and stop */
        __init_video_player();
        __trigger_video_play_stop(GLOBAL_SETTINGS);
        __set_video_audio_volume();
        __start_media_video();

        /* Break long E-Mail strings */
        // __break_long_mail_links_words();

        /* Init Animate On Scroll library */
        AOS.init({ once: true });

        /* Toggle the header scroll */
        // __handle_header_scroll();

        /* Toggle the main menu */
        __toggle_menu();
        __small_nav_section_anchor(GLOBAL_SETTINGS);

        /* Meta Menu Items Functions */
        __handle_meta_menu_item(GLOBAL_SETTINGS);

        /* Init the lightboxes */
        __init_lightboxes();
        __init_single_lightboxes();

        /* Init the slider */
        __init_free_slider();
        __hover_for_tooltip();
        __slider_widget_lists();

        /* Trigger modal function */
        __trigger_modal();
        __trigger_share_modal();
        __share_functions();

        /* Trigger the lightbox */
        __trigger_lightbox();
        __init_charts();

        window.addEventListener('scroll', () => {
            window.requestAnimationFrame(() => {
                let positions = __get_scroll_position();

                if (positions.relative > parseFloat(0.82)) {
                    $('img.fixed').each(async function (index, img) {
                        $(img).css('bottom', '300px');
                        $(img).css('opacity', '0');
                    });
                } else {
                    $('img.fixed').each(async function (index, img) {
                        $(img).css('bottom', '');
                        $(img).css('opacity', '1');
                    });
                }
            })
        }, { passive: true })

        /* Load tutorial */
        await __load_tutorial();

        /* Accept tutorial */
        await __accept_tutorial();

        /* Init the full page scroll */
        await __full_page_scroll(GLOBAL_SETTINGS);
        await __handle_key_navigation();

        /* End functions, reach the end of JS */
        __end();
    });
})(jQuery);
